import { selectTranslations } from 'app/pages/App/slice/selectors';
import {
  PassengerFormData,
  PassengerType,
} from 'app/pages/PassengerInfo/types';
import moment from 'moment';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
export interface CheckError {
  passengerId: string;
  type: PassengerType;
  length: number;
  max: number;
  message: string;
}
const MAX_LENGTH = 59;
const buildPassengerText = (p?: PassengerFormData): string => {
  if (!p) return '';
  const dob = p.dateOfBirth ? moment(p.dateOfBirth).format('DD/MM/YYYY') : '';
  return [p.title, p.lastName, p.firstName, dob].filter(Boolean).join('');
};
const PASSENGER_LABEL: Record<PassengerType, string> = {
  [PassengerType.ADULT]: 'b2b.txt.adult',
  [PassengerType.CHILD]: 'b2b.txt.child',
  [PassengerType.INFANT]: 'b2b.txt.infant',
};
export const usePassengerNameLengthCheck = (passengers: any[] = []) => {
  const translations = useSelector(selectTranslations);
  const check = useCallback(() => {
    const passengerMap = new Map(passengers.map(p => [p.id, p]));
    const errors: CheckError[] = [];
    passengers.forEach(p => {
      let text = '';
      if (p.type === PassengerType.ADULT || p.type === PassengerType.CHILD) {
        text = buildPassengerText(p);
      }
      if (p.type === PassengerType.INFANT) {
        const guardian = passengerMap.get(p.guardianId || '');
        text = buildPassengerText(p) + buildPassengerText(guardian);
      }
      if (text.length >= MAX_LENGTH) {
        const passengerText = buildPassengerText(p);
        const guardianText =
          p.type === PassengerType.INFANT
            ? buildPassengerText(passengerMap.get(p.guardianId || ''))
            : '';
        const passengerType = translations?.[PASSENGER_LABEL[p.type]];
        // const message =
        //   p.type === PassengerType.INFANT
        //     ? translations?.['b2b.txt.passengerGuardianTextMaxLength']
        //         ?.replace('${passengerText}', passengerText)
        //         ?.replace('${guardianText}', guardianText)
        //         ?.replace('${MAX_LENGTH}', MAX_LENGTH)
        //         ?.replace('${passengerType}', passengerType)
        //     : translations?.['b2b.txt.passengerTextMaxLength']
        //         ?.replace('${passengerText}', passengerText)
        //         ?.replace('${MAX_LENGTH}', MAX_LENGTH)
        //         ?.replace('${passengerType}', passengerType);
        const message =
          p.type === PassengerType.INFANT
            ? translations?.['b2b.txt.passengerGuardianTextMaxLength']?.replace(
                '${MAX_LENGTH}',
                MAX_LENGTH,
              )
            : translations?.['b2b.txt.passengerTextMaxLength']?.replace(
                '${MAX_LENGTH}',
                MAX_LENGTH,
              );
        errors.push({
          passengerId: p.id,
          type: p.type,
          length: text.length,
          max: MAX_LENGTH,
          message,
        });
      }
    });
    return {
      valid: errors.length === 0,
      errors,
    };
  }, [passengers]);
  return { check };
};
